import Vue from 'vue'

// import carousel from '~/components/helpers/carousel.vue'
import embedsrc from '~/components/helpers/embedsrc.vue'
import facebook from '~/components/helpers/facebook.vue'
import facebookShare from '~/components/helpers/facebook-share.vue'
// import gallery from '~/components/helpers/gallery.vue'
import lineShare from '~/components/helpers/line-share.vue'
import lineid from '~/components/helpers/lineid.vue'
import mail from '~/components/helpers/mail.vue'
import tel from '~/components/helpers/tel.vue'
import twitterShare from '~/components/helpers/twitter-share.vue'
import zImg from '~/components/helpers/zImg.vue'

// Vue.component('carousel', carousel)
Vue.component('embed-src', embedsrc)
Vue.component('facebook', facebook)
Vue.component('facebook-share', facebookShare)
// Vue.component('gallery', gallery)
Vue.component('line-share', lineShare)
Vue.component('lineid', lineid)
Vue.component('mail', mail)
Vue.component('tel', tel)
Vue.component('twitter-share', twitterShare)
Vue.component('z-img', zImg)

